<template>
  <div class="w-full h-full overflow-hidden bg-white pointer-events-auto">
    <img
      ref="imageSlideImageRef"
      class="object-contain w-full h-full pointer-events-none select-none transition-all"
      :src="slide.url"
      :style="{ ...(contentStyle as CSSStyleValue) }"
      :data-testid="`image-slide-image-${slide.page_number}`"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import type { SlideImage } from '@/entities/deck'
import { useImageLoadEvent } from '@/composables/useImageLoadEvent'
import { SLIDE_READY_TIMEOUT } from '@/lib/constants/meetings'

defineProps({
  slide: {
    type: Object as PropType<DeepReadonly<SlideImage>>,
    required: true,
  },
  contentStyle: {
    type: Object as PropType<Partial<CSSStyleDeclaration>>,
    default: () => ({}),
  },
})

const emit = defineEmits(['slide-ready', 'update:image-dimensions', 'update:annotations'])

const imageSlideImageRef = ref<HTMLImageElement | undefined>()

useImageLoadEvent(imageSlideImageRef, img => {
  emit('update:image-dimensions', { width: img.naturalWidth, height: img.naturalHeight })
  emit('update:annotations', { aspect: img.naturalWidth / img.naturalHeight })
  // Short timeout since it still takes a small amount of time for the image to actually show
  setTimeout(() => emit('slide-ready', true), SLIDE_READY_TIMEOUT)
})
</script>
